import styled from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';
import { hexToRgb } from '../../Utils/utils';

export type LinkButtonProps = SpaceProps;

export const LinkButton = styled.button<LinkButtonProps>`
  font-family: ${(props) => props.theme.fontLinkButton};
  font-size: 1.4rem;
  line-height: 25px;
  color: ${(props) => props.theme.textColor};
  background-color: transparent;
  border: none;
  border-radius: 4px;
  width: fit-content;
  height: 25px;
  padding: 0 12px;
  cursor: pointer;
  transition: all 0.2s;
  ${space} :hover {
    transform: translateY(-1px);
    background-color: ${(props) => hexToRgb(props.theme.colors.primary, { opacity: 15 })};
  }

  :active {
    transform: translateY(1px);
  }

  &.focus-visible {
    outline: none;
    box-shadow: 0px 0px 0px 2px ${(props) => props.theme.textColor};
  }
`;
